import { j as p } from "../../jsx-runtime-B6kdoens.js";
import { useCallback as b, useState as k, useEffect as M } from "react";
import { c as T, a as $ } from "../../index-CROKJrb5.js";
import { c as q, f as P } from "../../create-component-CBAeEoQ6.js";
import { FormControl as W } from "../FormControl/index.js";
import { b as G, F as H } from "../../FormControlContext-C7A4R-3o.js";
import { Typography as J } from "../Typography/index.js";
import { u as O } from "../../use-merge-refs-DEJnLwh4.js";
import { a as Q } from "../../as-num-DQjLjHSI.js";
import { useBrand as U } from "../../brand/context/index.js";
const X = T({
  base: "cur-aspect-square cur-bg-surface-neutral cur-border cur-border-border-subtle  cur-flex cur-items-center cur-justify-center",
  variants: {
    brand: {
      curology: "cur-rounded-sm",
      agency: "cur-rounded-none"
    },
    empty: {
      false: "cur-border-brand cur-border-2"
    },
    active: {
      true: "group-focus-within:cur-ring-2 group-focus-within:cur-ring-focus group-focus-within:cur-border-focus group-focus-within:cur-border"
    }
  }
}), Y = ({
  active: e,
  onClick: t,
  total: u,
  value: d
}) => {
  const s = U(), i = X({
    brand: s,
    empty: !d,
    active: e
  });
  return /* @__PURE__ */ p.jsx(
    J,
    {
      "aria-hidden": !0,
      as: "button",
      className: i,
      onClick: t,
      size: "body-lg",
      style: { width: `${1 / u * 100}%` },
      tabIndex: -1,
      type: "button",
      weight: "bold",
      children: d ?? (e && /* @__PURE__ */ p.jsx("div", { className: "cur-invisible cur-h-10 cur-max-h-full cur-border-l-2 group-focus-within:cur-visible group-focus-within:cur-animate-cursor-blink" }))
    }
  );
}, Z = ({
  className: e,
  digits: t,
  id: u,
  onBoxClick: d,
  selectionEnd: s,
  selectionStart: i,
  value: c
}) => /* @__PURE__ */ p.jsx(
  "label",
  {
    className: $("cur-flex cur-w-full cur-gap-2", e),
    htmlFor: u,
    children: Array.from(Array(t)).map((n, r) => /* @__PURE__ */ p.jsx(
      Y,
      {
        active: i !== void 0 && s !== void 0 && r >= i && (i === s ? r <= s : r < s),
        onClick: () => d(r),
        total: t,
        value: c[r]
      },
      `box-${r}`
    ))
  }
), ee = () => {
  const [e, t] = k(), u = b((n) => {
    t(n);
  }, []), [d, s] = k([void 0, void 0]), i = b(
    (n, r) => {
      e == null || e.setSelectionRange(n, r ?? n), e == null || e.focus();
    },
    [e]
  ), c = b(() => {
    const { selectionStart: n, selectionEnd: r } = e || {};
    s([n ?? void 0, r ?? void 0]);
  }, [e, s]);
  return M(() => (e == null || e.addEventListener("keyup", c), e == null || e.addEventListener("focus", c), e == null || e.addEventListener("blur", c), () => {
    e == null || e.removeEventListener("keyup", c), e == null || e.removeEventListener("focus", c), e == null || e.removeEventListener("blur", c);
  }), [e, c]), [u, i, ...d];
}, S = (e, t, u) => e.slice(0, t) + e.slice(u ?? t + 1), pe = q(
  "CodeInput",
  P(
    ({
      children: e,
      className: t,
      defaultValue: u,
      digits: d = 4,
      disabled: s,
      helperText: i,
      id: c,
      label: n,
      onChange: r,
      required: E,
      state: C,
      size: re,
      value: B,
      ...L
    }, N) => {
      const f = Q(d), [h, x] = G({
        disabled: s,
        id: c,
        state: C,
        value: B || u || ""
      }), m = h.value || "", [R, v, V, D] = ee(), F = b(
        (o) => {
          const a = o.target.selectionStart ?? 0;
          let l = o.target.value.replace(/[^0-9]{1,}/gi, "");
          l = (a > f ? l : S(l, a)).slice(0, f), x((w) => ({ ...w, value: l })), o.target.value = l, r == null || r(o, l), a < l.length ? v(a, a) : a === f && v(f - 1, f - 1);
        },
        [r, v, x, f]
      ), z = b(
        (o) => {
          const { key: a, target: l } = o, w = a === "Backspace", _ = a === "Delete", { selectionStart: g = 0, selectionEnd: j = 0 } = l;
          if (w || _) {
            o.preventDefault();
            let y;
            g !== j ? y = S(m, g ?? 0, j ?? 0) : y = g === m.length && w ? S(m, (g ?? 1) - 1) : S(m, g ?? 0), x((K) => ({
              ...K,
              value: y
            })), o.target.value = y, o.type = "change", r == null || r(
              o,
              y
            );
          }
        },
        [r, x, m]
      ), I = b(
        (o) => v(o),
        [v]
      ), A = O(R, N);
      return /* @__PURE__ */ p.jsx(H.Provider, { value: h, children: /* @__PURE__ */ p.jsxs(
        W,
        {
          className: t,
          fieldClassName: "cur-group",
          helperText: i,
          label: n,
          required: E,
          children: [
            /* @__PURE__ */ p.jsx(
              "input",
              {
                ref: A,
                autoComplete: "one-time-code",
                id: h.id,
                className: "cur-pointer-events-none cur-absolute -cur-z-10 cur-opacity-0",
                inputMode: "numeric",
                onKeyDown: z,
                onChange: F,
                pattern: "[0-9]*",
                value: m,
                ...L
              }
            ),
            /* @__PURE__ */ p.jsx(
              Z,
              {
                className: t,
                digits: f,
                id: h.id,
                onBoxClick: I,
                selectionEnd: D,
                selectionStart: V,
                value: m
              }
            )
          ]
        }
      ) });
    }
  )
);
export {
  pe as CodeInput
};
//# sourceMappingURL=index.js.map
